import A from './ActionCreators.js';
import { v4 } from 'uuid';

// Zip with undefined: zip([1,2], [4]) === [[1, 4], [2, undefined]]
const zip = (...arrays) => {
  const length = Math.max(...arrays.map(arr => arr.length));
  return Array.from({ length }, (_, i) => arrays.map(arr => arr[i]));
};

export function createImageSetsFromMultidimensionalImage(dispatch, multidimInfo, args) {
  let info = multidimInfo;

  let filename = (args.filenames && args.filenames[0]) || "";

  let newOrder = info.order.filter(axis => axis !== 'X' && axis !== 'Y');
  let dirId = (args.microscopyExperimentIds||[])[0] || v4();

  let { ndImageArray } = info;
  let isMultidim = Array.isArray(ndImageArray);
  let isSingleChannel = typeof(ndImageArray) === typeof("");
  
  let { dims, order } = multidimInfo;
  let shouldCreateMultidimArray = isMultidim && (dims.Z > 1 || dims.T > 1);

  let hasMoreThanOneImage = dims.Z * dims.T * dims.C > 1;

  let { nestedImageIds=[], nestedImageSetIds=[] } = args || {}

  let toDispatch = [];

  function recurse(arr, nestedImageIds, nestedImageSetIds, axisIdx, namePrefix) {
    console.log("arr is: ",arr)
    if (!Array.isArray(arr[0])) {
      // this is a list of channels
      let imageSetId = nestedImageSetIds; // (nestedImageSetIds && nestedImageSetIds[0]) || v4();
      if (typeof imageSetId !== 'string') {
        imageSetId = v4();
      }
      

      console.log("Array To Load In",arr);

      let axisName = order[axisIdx];
      const ids = arr.map((_,ii) => nestedImageIds && nestedImageIds[ii] || v4());
      const filenames = arr.map((_,i) => {
        let newName = namePrefix;
        if (arr.length > 1) newName += `${axisName}${i+1}`;
        return newName;
      });

      dispatch(A.startImageUploads({
        filenames,
        imageIds: ids,
        remoteStorageResourceIds:arr,
        imageSetIds: ids.map(_ => imageSetId),
        heights: ids.map(_ => info.dims.Y/info.dims.X),
        urls: ids.map(_ => undefined),
        uploadWidths: ids.map(_ => info.dims.X),
        grayscale: ids.map(_ => true),
        storageLocation:"s3",
        targetVersion:"raw-png",
        readIntoMemory:false,
        delayStorage:true,
        pendingRecords:false,
        processMedia:false,
      }));

      if (shouldCreateMultidimArray) {
        toDispatch.push(() => A.moveFilesystemItem({
          _id: imageSetId,
          to: dirId,
          ignoreNameCollision: true,
          itemType: "imageSets",
        }));
      } else {
        toDispatch.push(() => A.setFilesystemName({
          _id: imageSetId,
          filesystemName: filename,
          itemType: "imageSets",
        }));
      }
      return ids;
    } else {
      let axisName = order[axisIdx];
      return zip(arr, nestedImageIds || [], nestedImageSetIds || []).map(([sub, subImageIds, subImageSetIds], i) => {
        let indexInName = `${axisName}${i+1}` // 1-indexed for users
        let newName;
        if (arr.length === 1) {
          // skip this axis
          newName = namePrefix;
        } else {
          newName = namePrefix + indexInName;
        }
        console.log("sub recursion", sub, subImageIds, subImageSetIds);
        return recurse(sub, subImageIds, subImageSetIds, axisIdx + 1, newName);
      });
    }
  }


  let toRecurse = isMultidim ? ndImageArray : [ ndImageArray ]
  let imageIdNdArray = recurse(toRecurse, nestedImageIds, nestedImageSetIds, 0, hasMoreThanOneImage ? "" : filename)
    
  if (shouldCreateMultidimArray) {
    dispatch(A.createItem({
      type: "directories",
      inTopLevelParent: "imageSets",
      directoryType: "multidim",
      _id: dirId,
      filesystemName: args.filenames && args.filenames[0],
      multidim: {
        ndImageArray: imageIdNdArray,
        dims: info.dims,
        order: newOrder,
      }
    }))

    for (const action of toDispatch) {
      dispatch(action());
    }

    return dirId;
  } else {
    for (const action of toDispatch) {
      dispatch(action());
    }
  }
}
